import React, { useContext } from 'react'
import { Box } from '@hub/box'
import { Tab } from '@hub/tabs'
import { HubStyleObject } from '@hub/design-system-base'
import { LinkContext } from '../../../context'
import analyticsUtils from '../../../helpers/analytics-utils'
import trackEvent from '../../../helpers/analytics-utils/track-event'

interface TabItemListProps {
  tabName: string
  selectedColour: string
  url?: string
  sx?: HubStyleObject
}

export const TabItemList: React.FC<TabItemListProps> = ({
  tabName,
  selectedColour,
  url,
  sx = {},
}) => {
  const Link = useContext(LinkContext)
  const Component = url ? Box : Tab

  const onClick = (): void =>
    trackEvent(
      analyticsUtils.categories.UNIVERSAL_HEADER,
      analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN,
      tabName
    )

  return (
    <Component
      as={url ? props => <Link to={url} {...props} /> : undefined}
      _selected={{
        bg: 'smoke',
        fontWeight: 'bold',
        borderTopColor: selectedColour,
        color: 'licorice',
        outline: 'none',
      }}
      sx={{
        flexGrow: 1,
        borderWidth: '2px',
        color: 'quartz',
        fontSize: 'font-tiny',
        fontWeight: 'bold',
        paddingX: 'spacing-md',
        paddingY: 'spacing-sm',
        borderRightRadius: '2px',
        borderLeftRadius: '2px',
        borderTopRightRadius: '2px',
        borderTopLeftRadius: '2px',
        borderTopStyle: 'solid',
        borderTopColor: 'transparent',
        lineHeight: 'base',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        outline: 'none',
        ...sx,
      }}
      onClick={onClick}
    >
      {tabName}
    </Component>
  )
}
